import { fetcher } from 'services/helpers/responseHandler'

const getAnalytics = async () => {
  return fetcher.get('content/analytics')
}

const updateConfiguration = async (notificationContentId, configuration) => {
  return fetcher.put(`content/${notificationContentId}/configuration`, {
    messageTemplate: configuration.messageTemplate,
    isActive: configuration.isActive,
    medium: configuration.medium,
    hoursAfterPreviousCampaign: configuration.hoursAfterPreviousCampaign,
    messageMediaUrls: configuration.messageMedia ? [configuration.messageMedia] : []
  })
}

const getOtaBusterAnalytics = async () => {
  return fetcher.get('content/notification/ota-buster/analytics')
}

const contentApi = {
  getAnalytics,
  getOtaBusterAnalytics,
  updateConfiguration
}

export default contentApi
